<template>
  <v-dialog v-model="showModal" persistent max-width="400">
    <v-card class="text-sm-center pb-3">
      <v-card-title class="headline">
        <div class="text-sm-center message">
          {{message}}
        </div>
      </v-card-title>
      <v-card-text class="text-center">
        <v-progress-circular :size="70" :width="7" indeterminate color="primary"></v-progress-circular>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapFields } from '@/vueHelpers/vuex'

export default {
  computed: {
    ...mapFields('progressModal', [
      'showModal',
      'message'
    ])
  }
}
</script>

<style scoped>
.message {
  width: 100%
}
</style>
